import { c as _c } from "react/compiler-runtime";
import type { PlaybookDeploymentResponse, PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Badge, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type PlaybookVersionBadgeProps = {
  version?: PlaybookVersionNoGraph;
  activeDeployment?: PlaybookDeploymentResponse;
};
type VersionStatus = 'deployed' | 'deprecated' | null;
const PlaybookVersionBadge = t0 => {
  const $ = _c(23);
  const {
    version,
    activeDeployment
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "versionBadge"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    status,
    text
  } = useVersion(version);
  if (!version) {
    return null;
  }
  if (status === "deployed") {
    let t2;
    if ($[1] !== text) {
      t2 = <Badge variant="info">{text}</Badge>;
      $[1] = text;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const badge = t2;
    let t3;
    let t4;
    if ($[3] !== activeDeployment?.routingPolicy.versions || $[4] !== badge || $[5] !== t || $[6] !== version) {
      t4 = Symbol.for("react.early_return_sentinel");
      bb0: {
        const weight = activeDeployment?.routingPolicy.versions.find(v => v.versionId === version.id)?.weight;
        if (weight === undefined) {
          t4 = badge;
          break bb0;
        }
        t3 = weight === 0 ? t(_temp) : t(_temp2, {
          weight
        });
      }
      $[3] = activeDeployment?.routingPolicy.versions;
      $[4] = badge;
      $[5] = t;
      $[6] = version;
      $[7] = t3;
      $[8] = t4;
    } else {
      t3 = $[7];
      t4 = $[8];
    }
    if (t4 !== Symbol.for("react.early_return_sentinel")) {
      return t4;
    }
    const tooltip = t3;
    let t5;
    if ($[9] !== badge || $[10] !== tooltip) {
      t5 = <Tooltip content={tooltip}>{badge}</Tooltip>;
      $[9] = badge;
      $[10] = tooltip;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  if (status === "deprecated") {
    let t2;
    if ($[12] !== text) {
      t2 = <Badge variant="neutral">{text}</Badge>;
      $[12] = text;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    return t2;
  }
  let t2;
  if ($[14] !== t) {
    t2 = t(_temp3);
    $[14] = t;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t) {
    t3 = t(_temp4);
    $[16] = t;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t3) {
    t4 = <Badge variant="warning">{t3}</Badge>;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t2 || $[21] !== t4) {
    t5 = <Tooltip content={t2}>{t4}</Tooltip>;
    $[20] = t2;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
};
export const useVersion = version => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "versionBadge"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  if (!version) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        status: null,
        text: null
      };
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (version.isDeployed) {
    let t1;
    if ($[2] !== t) {
      t1 = t(_temp5);
      $[2] = t;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t1) {
      t2 = {
        status: "deployed",
        text: t1
      };
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (!version.isExecutable) {
    let t1;
    if ($[6] !== t) {
      t1 = t(_temp6);
      $[6] = t;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t2;
    if ($[8] !== t1) {
      t2 = {
        status: "deprecated",
        text: t1
      };
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      status: null,
      text: null
    };
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};
export default PlaybookVersionBadge;
function _temp($) {
  return $.deployedNoTrafficTooltip;
}
function _temp2($_0) {
  return $_0.deployedTooltip;
}
function _temp3($_1) {
  return $_1.notDeployedTooltip;
}
function _temp4($_2) {
  return $_2.notDeployed;
}
function _temp5($) {
  return $.deployed;
}
function _temp6($_0) {
  return $_0.deprecated;
}